<template>
  <div id="app" ref="app">
    <MainView />
    <Function />
    <O2vr />
    <Play :floor="'Rectangle294579029'" :ios="flag" />
    <!-- <Box :touch="flag" /> -->
    <Box />
    <Login />
    <!-- <HandShake :touch="flag" /> -->

    <a href="https://beian.miit.gov.cn/" target="_blank">
      <div class="beian">
        <p
          style="
            display: flex;
            align-item: center;
            justify-content: center;
            margin-bottom: 8px;
          "
        >
          <img
            src="./assets/img/icon.png"
            style="margin-right: 5px"
          />京公网安备11010802027774号
        </p>
        <p>京ICP备18055124号 北京元一畅想科技有限公司版权所有</p>
      </div>
    </a>
  </div>
</template>

<script>
import MainView from "./components/MainView.vue";
import Function from "./components/function.vue";
import O2vr from "../common/components/Car.vue";
import Play from "./components/play_new.vue";
import Box from "./components/box.vue";
import Login from "./components/login.vue";
import HandShake from "./components/handShake.vue";
import Bus from "../common/js/bus";
export default {
  name: "App",
  data() {
    return {
      flag: false,
    };
  },
  components: { MainView, O2vr, Function, Play, Box, Login, HandShake },
  created() {
    if (
      navigator.userAgent.match(/Android/i) ||
      navigator.userAgent.match(/webOS/i) ||
      navigator.userAgent.match(/iPhone/i) ||
      navigator.userAgent.match(/iPad/i) ||
      navigator.userAgent.match(/iPod/i) ||
      navigator.userAgent.match(/BlackBerry/i) ||
      navigator.userAgent.match(/Windows Phone/i)
    ) {
      this.flag = true;
    }

    // console.log(this.$o2Function.createDrag());
  },
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

#layout-container,
#mainrow,
#main-container {
  margin: auto, 0;
  height: 100%;
  width: 100%;
}
.beian {
  position: absolute;
  bottom: 20px;
  left: 0;
  right: 0;
  margin: auto;
  color: #fff;
  width: 350px;
  font-size: 12px;
}
</style>
